"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "27", height: "27", viewBox: "0 0 27 27", className: "Icon element-line", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M22.491 5.64L1.566 26.566.434 25.434 21.358 4.51l-1.67-1.666L27 0l-2.716 7.428L22.49 5.64z", fill: "#777", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/element-line.js
// module id = 1862
// module chunks = 0